import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import axios from "axios";
import api from "./api/axiosInstance";
import enUS from "./locales/en-US/common.json";
import esAR from "./locales/es-AR/common.json";

const resources = {
  "en-US": { translation: enUS },
  "es-AR": { translation: esAR },
};

const supportedLngs = Object.keys(resources);
const fallbackLng = "en-US";

const normalizeDetectedLanguage = (lng) => {
  if (!lng) return fallbackLng;
  if (supportedLngs.includes(lng)) return lng;
  const base = String(lng).split("-")[0].toLowerCase();
  if (base === "es") return "es-AR";
  if (base === "en") return "en-US";
  return fallbackLng;
};

const setAxiosLanguage = (lng) => {
  if (!lng) return;
  axios.defaults.headers.common["Accept-Language"] = lng;
  if (api?.defaults?.headers?.common) {
    api.defaults.headers.common["Accept-Language"] = lng;
  }
  localStorage.setItem("language", lng);
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,
    supportedLngs,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "language",
      caches: ["localStorage"],
      convertDetectedLanguage: normalizeDetectedLanguage,
    },
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
    nsSeparator: false,
    defaultNS: "translation",
  });

setAxiosLanguage(i18n.language || fallbackLng);
i18n.on("languageChanged", (lng) => setAxiosLanguage(lng));

export { setAxiosLanguage };
export default i18n;
